export const default_task = () => {
    return {
        id: null,
        name: null,
        description: null,
        image: null,
        url: null,
        steps: [],
        controls: [],
        controls_images: [],
        steps_images: [],
        positions: [],
        slq_location_id: null
    };
};

export const default_task_control = () => {
    return {
        id: null,
        sys_list_type: {},
        order: null,
        description: null,
        image: null,
        url: null
    };
};

export const default_task_step = () => {
    return {
        id: null,
        name: null,
        description: null,
        image: null,
        url: null
    };
};

export const default_params = () => {
    return {
        company_id: null,
        slq_location_id: null,
        filter: null,
        paginate: 1,
        page: 1,
        per_page: 10
    };
};

export default {
    companies: [],
    image: null,
    tasks: {data: []},
    types: [],
    modal_image: {
        show: false,
        data: null
    },
    modal: {
        show: false,
        step: 0
    },
    task: default_task(),
    task_step: default_task_step(),
    task_control: default_task_control(),
    params: default_params(),
    editing: false,
    editing_control: false,
    editing_step: false,
    positions: [],
    locations: []
};
